import {Platform, StyleSheet} from 'react-native';
import SkillzStyle from 'SkillzStyle';

export const DEFAULT_PRIMARY_BUTTON_COLOR = SkillzStyle.fullStyles.tabHighlightColor.color;
export const getDisabledColorFrom = (color:string) => SkillzStyle.convertToOpacity(color, SkillzStyle.fullStyles.opacityTertiary);

const {
  fontBold,
  fontSizeH3,
} = SkillzStyle.fullStyles;

export default StyleSheet.create({
  button: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 3,
    padding: 8,
  },
  buttonOrientation: {
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 3,
    padding: 8,
  },
  container: {
    overflow: 'hidden',
    borderRadius: 3,
  },
  title: {
    ...fontBold,
    ...fontSizeH3,
    lineHeight:20,
    textAlign: 'center',
    paddingVertical: 1,
  },
  iconContainer: {
    marginHorizontal: 5,
  },
  raised: {
    backgroundColor: '#fff',
    overflow: 'visible',
    ...Platform.select({
      android: {
        elevation: 4,
      },
      default: {
        shadowColor: 'rgba(0,0,0, .4)',
        shadowOffset: {height: 1, width: 1},
        shadowOpacity: 1,
        shadowRadius: 1,
      },
    }),
  },
  loading: {
    marginVertical: 2,
  },
});
  
